const namespace = 'bravissimo/products/';

export const GET_SEARCH_SUGGESTIONS_SUCCESS = `${namespace}GET_SEARCH_SUGGESTIONS_SUCCESS`;
export const GET_SEARCH_SUGGESTIONS_REQUEST = `${namespace}GET_SEARCH_SUGGESTIONS_REQUEST`;
export const GET_SEARCH_SUGGESTIONS_FAILURE = `${namespace}GET_SEARCH_SUGGESTIONS_FAILURE`;
